<template>
  <div class="create-order">
    <base-header class="pb-8 pt-4"/>
    <div class="container-fluid mt--7">
      <b-row v-if="loading">
        <b-col class="text-center">
          <b-spinner></b-spinner>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col sm="12" md="4">
          <b-card class="mb-3" :title="$t('Genel Bilgiler')">
            <b-form-group>
              <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Müşteri Seçimi") }} <span
                  style="color:red">*</span>
              </legend>
              <v-select v-model="basket.client" ref="clientSelect" :options="clients" @search="getClients"
                        @input="checkClient"></v-select>
            </b-form-group>

            <b-form-group>
              <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Satış Personeli") }} <span
                  style="color:red"></span>
              </legend>
              <v-select v-model="basket.employee_id" :options="employees" @input="checkClient"
                        v-if="employees && employees.length>0"></v-select>
              <small class="badge badge-danger" v-else>{{ $t("Uygun Satış Personeli Bulunamadı") }}</small>
            </b-form-group>


            <!--            <b-form-group>-->
            <!--              <label>İşlem Tipi</label>-->
            <!--              <b-form-select @change="changeBasketType" v-model="basket.type" :options="[-->
            <!--                { text: 'Satış', value: 'sale' },-->
            <!--              ]"/>-->
            <!--            </b-form-group>-->
            <div v-for="(basketItem,key) in basketItems" v-bind:key="key">

              <b-form-group>
                <label>{{ basketItem.name }} {{ $t("Teslim Tarihi") }}</label>
                <b-form-input type="date" v-model="basket.issue_date.find(bskt=>bskt.id==basketItem.id).date"/>
              </b-form-group>

              <b-form-group v-if="basket.type === 'rent'">
                <label>{{ basketItem.name }} {{ $t("İade Tarih") }}i</label>
                <b-form-input type="date" v-model="basket.delivery_date.find(bskt=>bskt.id==basketItem.id).date"/>
              </b-form-group>
            </div>
            <b-form-group v-if="basket.type === 'rent' && isGelinlik==true">
              <label>{{ $t("Düğün Tarihi") }}</label>
              <b-form-input type="date" v-model="basket.wedding_date"/>
            </b-form-group>
            <b-form-group v-if="basket.type === 'rent' && isGelinlik==true">
              <label>{{ $t("Fotoğraf Çekim Tarihi") }}</label>
              <b-form-input type="date" v-model="basket.photo_date"/>
            </b-form-group>

            <b-form-group>
              <label>{{ $t("Ödeme Tipi") }}</label>
              <b-form-select v-model="basket.payment_type" @change="changePaymentType" :options="[
                { text: 'Nakit', value: 'cash' },
                { text: 'Kredi Kartı', value: 'credit_cart' },
                { text: 'Havale / EFT', value: 'eft' },
               { text: 'Çek', value: 'check' },
               { text: 'Senet', value: 'bill' },
                { text: 'Çoklu Ödeme', value: 'multiple_payment', disabled:basket.payment_style!=='now_and_later' },
              ]"/>
            </b-form-group>

            <b-form-group v-if="!['bill','check'].includes(basket.payment_type)">
              <label>{{ $t("Ödeme Şekli") }}</label>
              <b-form-select @change="basket.payment_type='cash'" v-model="basket.payment_style" :options="[
                  { value: 'now', text: 'Tamamı Peşin', },
                  { value: 'now_and_later', text: 'Peşinat + Teslimde', },
                  { value: 'later', text: 'Tamamı Teslimde' },
                  { value: 'installment', text: 'Taksitli Ödeme', },
                ]"/>
            </b-form-group>

            <b-form-group v-if="['now_and_later','installment'].includes(basket.payment_style)" v-model="order.pesinat">
              <label>{{ $t("Peşinat") }}</label>
              <b-form-input type="number" :readonly="basket.payment_type=='multiple_payment'" ref="pesinat"
                            v-model="basket.price"/>
            </b-form-group>

            <b-form-group v-if="['installment'].includes(basket.payment_style)">
              <label>{{ $t("Taksit Sayısı") }}</label>
              <b-form-input type="number" ref="installmentcount" min="1"
                            v-model="basket.installmentcount"/>
            </b-form-group>
            <b-form-group>
              <label>{{ $t("Satış Tarihi") }}</label>
              <b-form-input type="date" ref="sale_date" min="1"
                            v-model="basket.sale_date"/>
            </b-form-group>

            <b-row v-if="basket.payment_type === 'multiple_payment'">


              <b-col md="4">
                <b-form-group>
                  <label>{{ $t("Kredi Kartı") }}</label>
                  <b-form-input type="number" v-model="basket.payment_types.credit_cart"/>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>{{ $t("Nakit") }}</label>
                  <b-form-input type="number" v-model="basket.payment_types.cash"/>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label>{{ $t("Havale / EFT") }}</label>
                  <b-form-input type="number" v-model="basket.payment_types.eft"/>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group v-if="!['now','installment'].includes(basket.payment_style) || ['check','bill'].includes(basket.payment_type)">
              <label>{{ $t("Son Ödeme Tarihi") }}</label>
              <b-form-input type="date" v-model="basket.last_payment_date"/>
            </b-form-group>
          </b-card>

        </b-col>

        <b-col sm="12" md="8" @click="getServices">
          <b-card no-body>
            <b-card-header>
              <div class="align-items-center row">
                <div class="col d-flex align-items-center">
                  <h3 class="card-title mb-0" style="width:150px;">{{ $t("Ürün Ekle") }}</h3>
                  <div class="text-sm ml-4" style="width:100%;">
                    <b-form-group class="mb-0" @mouseover="getServices">
                      <v-select v-model="keyword" :options="serviceOptions" :placeholder="servicePlaceholder"
                                @input="addItem"/>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </b-card-header>
          </b-card>

          <b-card class="mt-3 mb-3" no-body>
            <b-table
                class="mb-3 rounded"
                :fields="[
                { key: 'name', label: $t('Ürün Adı') },
                { key: 'price', label: $t('Birim Fiyatı'), thStyle: {width: '160px'} },
                { key: 'tax', label: $t('KDV'), thStyle: {width: '160px'}  },
                { key: 'piece', label: $t('ADET'), thStyle: {width: '160px'}  },
                { key: 'discount', label: $t('İndirim(Tutar)'), thStyle: {width: '160px'}  },
                { key: 'discountRate', label: $t('İndirim(Oran)'), thStyle: {width: '160px'}  },
                { key: 'action', label: '' },
              ]"
                :items="basketItems" responsive>

              <template v-slot:cell(name)="data">
                {{ data.item.name }} ({{ data.item.barcode }})
              </template>
              <template v-slot:cell(price)="data">
                <b-form-input type="number" v-model="data.item.price"/>
              </template>
              <template v-slot:cell(piece)="data">
                <b-form-input type="number" v-model="data.item.piece" style="width: 60px"/>
<!--                <h1>test</h1>-->
              </template>
              <template v-slot:cell(tax)="data">
                <b-form-input type="number" v-model="data.item.tax" style="width: 60px"/>
              </template>
              <template v-slot:cell(discount)="data">
                <b-form-input type="number" v-model="data.item.discount"/>
              </template>
              <template v-slot:cell(discountRate)="data">
                <b-form-input type="number" max="100" v-model="data.item.discountRate" placeholder="İndirim Oranı"/>
              </template>

              <template v-slot:cell(action)="data">
                <span v-if="data.item.discountRate>0">
                                                                      {{
                    ceil(data.item.piece * ((data.item.price - ((data.item.price * data.item.discountRate) / 100)) + (data.item.price * data.item.tax / 100)))
                  }} TL


                </span>
                <span v-else>
                                  {{
                    ceil(data.item.piece * ((data.item.price - data.item.discount) + ((data.item.price) * data.item.tax / 100)))
                  }} TL


                </span>

                                <b-button variant="success" size="sm" @click="increase(data.item)" class="pt-2 ml-2"><i
                                    class="ni ni-fat-add"></i></b-button>
                <b-button variant="danger" size="sm" @click="decrease(data.item, data.key)" class="pt-2"><i
                    class="ni ni-fat-delete"></i></b-button>
              </template>
            </b-table>
            <!--            last_payment_date = price-->
            <!--            price = pesinat-->
            <b-card-footer>
              <h4>{{ $t("Toplam") }} - {{ totalPrice }} TL</h4>
            </b-card-footer>
          </b-card>


          <b-card :title="$t('Sipariş Notu')" class="mb-3">
            <b-form-group>
              <b-form-textarea v-model="order.note" rows="5"/>
            </b-form-group>
          </b-card>

          <div class="d-flex">
            <b-button
                :disabled="false"
                :variant=" isDone ? 'primary' : 'warning'" @click="createProcess" block>
              {{ isDone ? 'Oluşturuldu!' : 'Oluştur!' }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- Client Modal -->
    <b-modal
        ref="createClient"
        :title="$t('Müşteri Oluştur')"
        @ok="saveClient"
        @hide="resetClientModal"
        ok-title="Kaydet"
        cancel-title="İptal"
    >
      <!--      <b-form-group label="Tip">-->
      <!--        <v-select v-model="clientModal.type" :options="[-->
      <!--          {-->
      <!--        label:'Kurumsal',value:'business'-->
      <!--      },-->
      <!--      {-->
      <!--        label:'Bireysel',value:'person'-->
      <!--      }-->
      <!--      ]"></v-select>-->
      <!--      </b-form-group>-->


      <b-form-group label="Ad Soyad">
        <b-form-input v-model="clientModal.full_name"></b-form-input>
      </b-form-group>
      <b-form-group :label="$t('GSM')">
        <b-form-input
            v-model="clientModal.gsm"
            v-mask="'+90 (###) ### ####'"
        ></b-form-input>
      </b-form-group>
      <b-form-group :label="$t('GSM(Yakını)')">
        <b-form-input
            v-model="clientModal.gsm2"
            v-mask="'+90 (###) ### ####'"
        ></b-form-input>
      </b-form-group>

      <b-form-group :label="$t('Adres')">
        <b-form-input v-model="clientModal.address"></b-form-input>
      </b-form-group>
      <!--      <b-form-group label="E-mail">-->
      <!--        <b-form-input v-model="clientModal.email"></b-form-input>-->
      <!--      </b-form-group>-->
    </b-modal>
    <!--#Client Modal -->

    <b-modal ref="contractModal">
<!--      <b-button variant="info" @click="downloadSaleRentContract">{{ basket.type === 'sale' ? 'Satış' : 'Kiralama' }}-->
<!--        {{ $t("Sözleşmesi İndir") }}-->
<!--      </b-button>-->
      <b-button variant="success" block @click="downloadOrderContract">{{ $t("Sipariş Sözleşmesi İndir") }}</b-button>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$refs.contractModal.hide()">{{ $t("Kapat") }}</b-button>
      </template>
    </b-modal>


    <b-modal ref="modal" :title="$t('Kuaför Randevu Kaydı')">
      <b-form-group>
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Müşteri") }} <span
            style="color:red"></span></legend>
        <h2>{{ basket.client.label }}</h2>
        <!--        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Ürün") }} <span-->
        <!--            style="color:red"></span></legend>-->
        <!--        <h2>{{basketItems.length>0 && basketItems[basketItems.length-1].name }}</h2>-->
        <v-select v-model="basket.client" :options="clients" @input="checkClient" v-if="false"></v-select>
      </b-form-group>


      <b-row>
        <b-col sm="8">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Başlangıç Tarihi") }} <span
                style="color:red">*</span>
            </legend>
            <b-form-input v-model="calendarModal.start_date" type="date"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Başlangıç Saati") }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.start_time" type="time"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>


      <b-row>
        <b-col sm="8">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Bitiş Tarihi") }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.end_date" type="date"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t("Bitiş Saati") }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.end_time" type="time"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>

          <b-form-group :label="$t('Açıklama')">
            <b-textarea v-model="calendarModal.description"></b-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <!--      <b-form-group>-->
      <!--        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">İlgili Çalışan <span style="color:red">*</span></legend>-->
      <!--        <v-select v-model="calendarModal.employee" :options="employees" />-->
      <!--      </b-form-group>-->

      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="left">
            <b-form-checkbox v-model="calendarModal.sendSMS">{{ $t("Bildirim SMS'i Gönder") }}</b-form-checkbox>
          </div>
          <div class="right">
            <b-button @click="hideModal">İptal</b-button>
            <b-button variant="primary" @click="saveAppointment" class="loading-button"
                      :disabled="$v.$invalid || buttonLoading">
              <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t("Kaydet") }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment';
import {required} from "vuelidate/lib/validators";
import request from "../request";


export default {
  name: 'OrderCreate',

  validations: {
    calendarModal: {
      // client: {
      //   value: {required}
      // },
      start_date: {required},
      start_time: {required},
      end_date: {required},
      end_time: {required},
    }
  },
  data() {
    return {
      servicePlaceholder: 'Ürün Arayın',
      serviceOptions: [],
      isGelinlik: false,
      employees: [],
      loading: false,
      isDone: false,
      buttonLoading: false,
      saleRentContractId: '',
      orderContractId: '',
      calendarModal: {},
      keyword: '',
      services: null,
      basket: {
        sale_date:moment().format('YYYY-MM-DD'),
        payment_types: {
          eft: 0,
          credit_cart: 0,
          cash: 0
        },
        installmentcount: 0,
        client: '',
        type: 'sale',
        payment_style: 'now_and_later',
        payment_type: 'cash',
        // issue_date: moment().format('YYYY-MM-DD'),
        last_payment_date: moment().add(1, "days").format('YYYY-MM-DD'),
        issue_date: [],
        delivery_date: [],
        photo_date: null,
        wedding_date: moment().format('YYYY-MM-DD'),
        price: 0,
        employee_id: ''
      },
      clients: [],
      orderStatuses: {},
      basketItems: [],
      clientModal: {
        full_name: "",
        gsm: "",
        gsm2: "",
        email: "",
        address: "",
        // type: 'Bireysel'
      },
      order: {},
    }
  },
  watch: {

    basket: {

      handler(val) {
        let ptype=this.basket.payment_type;
        if(['bill','check'].includes(ptype)){
          this.basket.payment_style='later'
          console.log(this.basket.payment_style)
        }
        const values = Object.values(val.payment_types)
        if (values.some(e => e > 0)) {
          const totalPrice = values.reduce((total, num) => total + parseInt(num), 0)
          this.basket.price = totalPrice
        }
      },
      deep: true
    },
  },
  computed: {
    ...mapGetters(['user']),
    discount() {
      let discount = 0;
      this.basketItems.map(item => {
        discount += item.discount || 0;
      });
      return discount;
    },
    totalPrice() {
      let price = 0;
      this.basketItems.map(item => {
        if (item.discountRate > 0)
          price += (item.piece * ((item.price - ((item.price * item.discountRate) / 100))) + (item.price * item.tax / 100));

        else
          price += item.piece * (
              (item.price - item.discount) + (item.price * item.tax / 100)
          );
      });
      return this.ceil(price);
    }
  },
  methods: {
    ...mapActions(['getOrderScreen', 'createOrderScreen', 'createClientVSelect', 'getContract', 'createCoiffeurAppointment']),
    getServices(e) {
      if (this.serviceOptions.length < 1) {

        this.servicePlaceholder = "ürünler yüklenene kadar bekleyiniz."
        request.get('/processes/services', {
          params: {
            keyword: e
          }
        }).then(res => {

          this.serviceOptions = res.data.map(item => {
            return {
              label: `${item.name} (${item.barcode}) (${item.category_name})`,
              value: item.id,
            };
          });
          this.services = res.data
        }).finally(() => {

          this.servicePlaceholder = 'Ürün Arayınız...'
        })
      }
    },
    async getClients(e) {
      await request.get('/processes/clients', {
        params: {
          keyword: e
        }
      }).then(res => {
        // this.clients.push([...res.data])
        this.clients = []
        this.clients = this.clients.concat(res.data)

      }).catch(e => {
        this.error(e.message)
      })
      this.clients.unshift({label: "Yeni Oluştur", value: "create_new"});


    },
    saveAppointment() {
      this.buttonLoading = true;
      this.createCoiffeurAppointment({...this.calendarModal, client: {value: this.basket.client.value}, services: []})
          .then(response => {
            this.success(response.data.message)
            this.buttonLoading = false;
            this.hideModal()
          }).catch(error => {
        this.error(error.response.data.message)
        this.buttonLoading = false;
      })
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    changePaymentType() {

      this.basketItems.forEach(item => {

        if (this.basket.payment_type == 'credit_cart') {
          item.tax = this.user.company.creditcart_kdv
        } else {
          item.tax = this.services.find(service => service.id == item.id).tax

        }

      })

    },
    changeBasketType() {
      this.basketItems.forEach(item => {
        if (this.basket.type == 'rent')
          item.price = this.services.find(service => service.id == item.id).rent_price
        else
          item.price = this.services.find(service => service.id == item.id).price

      })
    },
    downloadSaleRentContract() {
      this.downloadContract(this.saleRentContractId);
    },
    downloadOrderContract() {
      this.downloadContract(this.orderContractId);
    },
    downloadContract(contractId) {
      this.getContract(contractId).then(response => {
        // Open the print window
        const prtHtml = response.data.contract;
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        WinPrint.document.write(`<!DOCTYPE html>
          <html>
            <head>
            </head>
            <body>
              ${prtHtml}
            </body>
          </html>`);
        WinPrint.document.close();
        WinPrint.focus();
        // WinPrint.print();
        // WinPrint.close();
      });
    },
    saveClient() {
      const request = {
        ...this.clientModal,
        type: "client"
      };
      this.createClientVSelect(request).then(response => {
        this.clients.push(response.data);
        this.basket.client = response.data;
        this.success("Müşteri başarıyla oluşturuldu!");
      }).catch(error => {
        this.error(error.response.data.message);
      });
    },
    resetClientModal() {
      this.clientModal = {
        full_name: "",
        gsm: "",
        email: ""
      };
    },
    checkClient() {
      if (this.basket.client && this.basket.client.value === "create_new") {
        this.$refs.createClient.show();
      }
      // this.clientModal.client.value = this.basketItems.client
    },
    increase(item) {
      item.piece++;
    },
    decrease(item, key) {
      if (item.piece > 1) {
        item.piece--;
      } else {
        this.isGelinlik = false
        let ddate = this.basket.delivery_date.find(date => date.id == item.id);
        let iof = this.basket.delivery_date.indexOf(ddate);
        this.basket.delivery_date.splice(iof, 1)
        this.basket.issue_date.splice(iof, 1)
        this.basketItems.splice(key, 1);

        this.basketItems.forEach(item => {
          if (item.category && item.category.name == 'GELİNLİK')
            this.isGelinlik = true
        })
      }
    },
    /**
     * Create order
     */
    createProcess(e) {
      this.isDone = true;
      e.preventDefault();
      this.createOrderScreen({
        services: this.basketItems,
        client_id: this.basket.client.value,
        employee_id: this.basket.employee_id.value,
        type: this.basket.type,
        price: this.basket.price,
        issue_date: this.basket.issue_date,
        delivery_date: this.basket.delivery_date,
        wedding_date: this.basket.wedding_date,
        photo_date: this.basket.photo_date,
        payment_style: this.basket.payment_style,
        installmentcount: this.basket.installmentcount,
        payment_type: this.basket.payment_type,
        payment_types: this.basket.payment_types,
        last_payment_date: this.basket.last_payment_date,
        order_details: this.order,
        sale_date: this.basket.sale_date,
      }).then(response => {
        this.saleRentContractId = response.data.sale_rent_contract_id;
        this.orderContractId = response.data.order_contract_id;
        this.success(response.data.message);
        this.isDone = true
        this.$refs.contractModal.show();
      }).catch(error => {
        this.isDone = false
        this.error(error.response.data.message);
      });
    },
    ceil(p) {
      return Math.ceil(p);
    },
    addItem() {
      setTimeout(() => {
        let service = this.services.find(i => i.id === this.keyword.value);

        if (service.category && (service.category.name == "KUAFÖR")) {
          if (this.basket.client.key == undefined) {
            this.error(this.$i18n.t('Lütfen Önce Müşteri Seçiniz!'))
            this.keyword = null;
            return
          }
          this.$refs.modal.show()
        }
        if (service.category && (service.category.name.includes('GELİNLİK'))) {
          this.isGelinlik = true
        }


        if (service) {
          service = JSON.parse(JSON.stringify(service));
          let price = this.basket.type === 'rent' ? service.rent_price : service.price;
          if (this.basket.payment_type == 'credit_cart')
            service.tax = this.user.company.creditcart_kdv
          this.basketItems.push({
            id: service.id,
            name: service.name,
            barcode: service.barcode,
            price: price,
            piece: 1,
            tax: service.tax,
            discount: 0,
            discountRate: 0,
            category: service.category
          });
          this.basket.delivery_date.push({
            'id': service.id,
            'date': moment().format('YYYY-MM-DD')
          })
          this.basket.issue_date.push({
            'id': service.id,
            'date': moment().format('YYYY-MM-DD')
          })
        }


        this.keyword = null;
      }, 200);
    },
  },
  async mounted() {
    // await this.getServices()
    this.loading = true;
    await this.getOrderScreen().then(data => data.data).then(response => {
      // this.services = response.services;
      // this.serviceOptions = response.services.map(item => {
      //   return {
      //     label: `${item.name} (${item.barcode}) (${item.category_name})`,
      //     value: item.id,
      //   };
      // });

      // this.clients = response.clients;
      this.clients.unshift({label: "Yeni Oluştur", value: "create_new"});
      this.employees = response.employees
      // this.employees.unshift({label: "Yeni Oluştur", value: "create_new"});

      this.loading = false;


    }).catch(error => {
      this.error(error.response.data.message);
      this.loading = false;
    })


  },
}
</script>

